module.exports = __webpack_public_path__ + "img/top-list-left7.976e46bf.png";